module.exports = __webpack_public_path__ + "img/002.c3ea404e.png";